// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppstoreFilledSvg from "@fishx/icons-svg/es/asn/AppstoreFilled";
import FishxIcon from '../components/FishxIcon';

var AppstoreFilled = function AppstoreFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreFilledSvg
  }));
};

AppstoreFilled.displayName = 'AppstoreFilled';
export default React.forwardRef(AppstoreFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AppstoreFilled.js
// module id = 2010
// module chunks = 0